
import App from './App.vue'
import { createApp } from 'vue'
import { createGtm } from '@gtm-support/vue-gtm';
import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import { VueMaskDirective } from 'v-mask';
import { i18n } from './vue-zina-router';
import VueKinesis from "vue-kinesis";
import VueScrollTo from "vue-scrollto";
import VueEasyLightbox from 'vue-easy-lightbox'
import router from './router'
import store from './store';
import vClickOutside from "click-outside-vue3"
import components from "@/components/UI";
import directives from "@/directives";
import VueScreen from 'vue-screen';
import VueSplide from '@splidejs/vue-splide';
import './registerServiceWorker';
import './tailwind.css'
import 'animate.css'

const metaManager = createMetaManager();
const app = createApp(App);

const vMaskV2 = VueMaskDirective;
const vMaskV3 = {
    beforeMount: vMaskV2.bind,
    updated: vMaskV2.componentUpdated,
    unmounted: vMaskV2.unbind
};

directives.forEach(directive => {
    app.directive(directive.name, directive);
});

components.forEach(component => {
    app.component(component.name, component);
});

app
    .use(VueSplide)
    .use(router)
    .use(
      createGtm({
        id: 'GTM-MXCTP5D', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
        // queryParams: {
        //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
        //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
        //   gtm_preview: 'env-4',
        //   gtm_cookies_win: 'x',
        // },
        defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
        compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
        // nonce: '2726c7f26c', // Will add `nonce` to the script tag
        enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
        debug: false, // Whether or not display console logs debugs (optional)
        // loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
        trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
      }),
    )
    .use(store)
    .use(metaManager, { refreshOnceOnNavigation: true })
    .use(metaPlugin)
    .use(i18n)
    .use(VueKinesis)
    .use(vClickOutside)
    .use(VueEasyLightbox)
    .directive('mask', vMaskV3)
    .use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    })
    .use(VueScreen, 'tailwind')
    .mount('#app')
